export default "__VITE_ASSET__Cuh$f2Or__"